











import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import { ReportNode, QuestionData } from '@/utils/ReportUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
  },

  computed: {
    answer: {
      get(): any {
        return this.value.data?.participation?.answer || {};
      },
      set(answer: any) {
        if (this.value.data.participation) {
          this.value.data.participation.answer = answer;
        }
      },
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },
  },

  methods: {
    async handleChange() {
      this.$emit('dirty');
      if (!(await (this.$refs.observer as any).validate())) {
        this.value.data.valid = false;
      } else {
        this.value.data.valid = true;

        if (this.value.data.participation) {
          let completeness = 0;
          if (
            this.answer.line1 !== undefined &&
            this.answer.line1?.length > 0
          ) {
            completeness++;
          }
          if (
            this.answer.province !== undefined &&
            this.answer.province?.length > 0
          ) {
            completeness++;
          }
          if (
            this.answer.postalcode !== undefined &&
            this.answer.postalcode?.length > 0
          ) {
            completeness++;
          }
          this.value.data.participation.completeness = completeness / 3;
        }
      }
    },
  },
});
